(function ($) {
  console.warn('This widget has been deprecated. Please use jQuery Chosen instead in core/modules/chosen');

  var instance = 0;
  var f = 0;

  $.widget('nmk.jcombobox', {

    // Options
    options: {
      delay: 300,
      minLength: 1,
      source: null,	// null - uses existing options	|| {"key":"value"} || string/url - sends search parameter, expects JSON result
      text: null,		// default text to appear in combobox, disappears on focus
      disabled: false,	// boolean
      selectBox: false,	// If true -- disable combobox-textfield input box, combobox will act as a styled Select box.
      showFirstOption: false,	// If true -- show the first <option> in the combobox by default, otherwise display a blank <option> by default
      sort: null,		// FUTURE -  null, asc (numeric), desc(numeric), alpha
      staticDropdown: false,	// FUTURE - if true -- do not repopulate dropdown with whole dictionary of a partially entered field, instead show only matching results
      allowFreeEntries: false, // FUTURE - if true -- allow user to enter a textfield value that does not have a match
      expandOnFocus: true,	// FUTURE - if true -- expand dropdown menu on textfield focus
    },

    _create: function () {
      instance++;				// Instance counter for assigning unique ID
      instance = '';

      this.element.addClass('combobox-ui');
      this.element.css({ display: 'none' }).wrap('<div class="combobox-wrapper"/>');
      this._dictionary = {};
      this._dropdownMenu = $('<div class="combobox-dropdown-menu"><ul></ul></div>');

      var self = this;
      // If no source defined, use options existing in select
      if (this.options.source == null) {
        var initialOptionsArray = {};
        $('option', this.element).each(function () {
          var k = $(this).val();
          var v = $(this).text();
          initialOptionsArray[k] = v;

          if (v != '') {
            initialOptionsArray[k] = v;
          }
        }).remove();
        this._dictionary = initialOptionsArray;
      } else if ($.type(this.options.source) == 'string') {
        $.ajax({
          url: this.options.source,
          type: 'POST',
          data: '',
          dataType: 'JSON',
          async: false,
          beforeSend: function () {
            self._spinnerOn();
            self.element.trigger('search');
          },
          complete: function (result) {
            self._spinnerOff();
            self.addRow($.parseJSON(result.responseText), self._dropdownMenu);
            self.element.trigger('response');
          },
        });
      } else {
        self.addRow(this.options.source, self._dropdownMenu);
      }

      var isDisabled = ''; 	// blank string
      if (this.options.selectBox == true) {
        isDisabled = 'readonly="READONLY"';
      } else {
        isDisabled = '';
      }

      this._wrapper = this.element.parent('.combobox-wrapper').prepend('<input type="text" class="combobox-textfield" ' + isDisabled + ' />');

      this._search = this._wrapper.children('.combobox-textfield');
      this._search.after('<span class="combobox-dropdown-button"/>');
      this._dropdownButton = this._search.next('.combobox-dropdown-button');
      this._dropdownButton.html('<i class="fa fa-caret-down"/>');
      this._wrapper.append(this._dropdownMenu);

      this._search.val(this.options.text);

      this._updateResults();

      if (this.options.showFirstOption) {
        $('.combobox-dropdown-item:first').click();
      }

      // Search field listeners
      var searchResult;
      self = this;
      this._on(this._search, {

        click: function (e) {
          if (this.options.selectBox || this.options.expandOnFocus) {
            this._dropdownButton.trigger('click');
          }

          if (this._search.val() == this.options.text) {
            this._search.val('');
          }
        },

        keydown: function (e) {
          if (e.keyCode == '9') {
            if ($('.combobox-dropdown-item.focus', this._dropdownMenu).size() >> 0) {
              $('.combobox-dropdown-item.focus', this._dropdownMenu).trigger('click');
            }
            // this.element.next('.combobox-textfield').focus();
          }
        },

        keyup: function (e) {
          // if(this._dropdownMenu.is(':visible') == false) this._updateResults();

          // Disregard shift and tab keys - bug fix for tabbing between comboboxes
          if (e.keyCode == '16') {

          } else if (e.keyCode == 13) {
            if (this._dropdownMenu.is(':visible') && $('.combobox-dropdown-item.focus', this._dropdownMenu).size() == 1) {
              this._search.val($('.combobox-dropdown-item.focus', this._dropdownMenu).html());
              self.closeMenu();
              self.updateSelect();
            }
          } else if (e.keyCode == 40) {
            if (this._dropdownMenu.is(':visible')) {
              if ($('.combobox-dropdown-item.focus', this._dropdownMenu).size() == 0) {
                $('.combobox-dropdown-item:first', this._dropdownMenu).addClass('focus');
              } else {
                $('.combobox-dropdown-item.focus', this._dropdownMenu).removeClass('focus').next().addClass('focus');
              }
            } else if ($('.combobox-dropdown-item', this._dropdownMenu).size() << 2 || $.type(this.options.source) == 'string') {
              this._updateResults();
              this.openMenu();
            } else {
              this.openMenu();
              $('.combobox-dropdown-item:first', this._dropdownMenu).addClass('focus');
            }
          } else if (e.keyCode == 38) {
            if (this._dropdownMenu.is(':visible')) {
              if ($('.combobox-dropdown-item.focus', this._dropdownMenu).size() == 0) {
                $('.combobox-dropdown-item:last', this._dropdownMenu).addClass('focus');
              } else {
                $('.combobox-dropdown-item.focus', this._dropdownMenu).removeClass('focus').prev().addClass('focus');
              }
            }
          } else if (e.keyCode == 27) {
            this.closeMenu();
          } else {
            clearTimeout($.data(this, 'timer'));
            var wait = setTimeout(function () {
              self._updateResults(self.doSearch(self._dictionary, self._search.val()), self._dropdownMenu, self._dictionary);
              // self._dropdownMenu.trigger('open');
            }, this.options.delay);
            $(this).data('timer', wait);
          }
        },

        // Search field Text option listeners
        focus: function () {
          // wtf? fires hundreds of times - stuff moved to click:

        },

        blur: function () {
          if (this._search.val() == '') {
            this._search.val(this.options.text);
          }
          console.log('blur');
        },

      });

      // Click handlers
      this._on(this._dropdownButton, {
        click: 'toggleMenu',
      });

      var itemSelector = this._dropdownMenu.children().children('.combobox-dropdown-item');
      this._setupListClickHandlers();

      this._updateResults();

      /*			if(this.element.children('option[value=""]').size() == 0){
				this.element.prepend('<option value=""></option>');
			}

			this.element.children('option:first').prop('selected', true); */

      self.element.trigger('create');
    },

    _setupListClickHandlers: function () {
      var self = this;

      this._off(this._dropdownMenu.children('ul').children('.combobox-dropdown-item'));

      this._on(this._dropdownMenu.children('ul').children('.combobox-dropdown-item'), {
        click: function (e) {
          self._updateResults(self.doSearch(self._dictionary, $(this).html()));
          self._search.val(this._specialChars(e.target.innerHTML));
          self.closeMenu();
          self.updateSelect($(this).html());
          this.element.trigger('change');
          self.element.trigger('select');
        },
      });

      /* $(".combobox-dropdown-item", self._dropdownMenu).on('click',  function(e){
				//return;
				self._updateResults(self.doSearch(self._dictionary, $(this).html()));
				self._search.val(e.target.innerHTML);
				self.closeMenu();
				self.updateSelect($(this).html());
			}); */
    },

    addRow: function (kv) {
      var self = this;
      $.each(kv, function (k, v) {
        if (v != '') {
          self._dictionary[k] = v;
          self.element.append('<option value="' + k + '">' + v + '</option>');
          self._dropdownMenu.children('ul').append('<li class="combobox-dropdown-item" data-value="' + k + '">' + v + '</li>');
        }
      });

      // context.children('ul.combobox-dropdown-menu').append('<li class="combobox-dropdown-item" data-value="' + k + '">' + v + '</li>');
    },

    removeLi: function (k, context) {
      $.each(k, function () {

      });
    },

    doSearch: function (sample, term) {
      var self = this;
      var results = {};

      if ($.type(term) == 'undefined' || term.length < this.options.minLength || term.length == 0) {
        return {};
      }

      term = term.toLowerCase();

      /* if($.type(this.options.source) == 'string'){
				$.ajax({
					url: this.options.source,
					type: 'POST',
					data: term,
					dataType: 'JSON',
					async: false,
					beforeSend: function(){
						self._spinnerOn();
						self.element.trigger('search');
					},
					complete: function(result){
						self._spinnerOff();
						results = $.parseJSON(result.responseText);
						self.element.trigger('response');
					}
				});
			} else { */

      for (var k in sample) {
        var v = sample[k];
        if (v.toLowerCase().match(term)) {
	                    results[k] = v;
        }
      }
      /* } */
      return results;
    },

    // public
    updateDictionary: function (results) {
      var self = this;
      if ($.isEmptyObject(results) == true || $.type(results) != 'object') {
        return;
      }

      $('.combobox-dropdown-item', this._dropdownMenu).remove();
      $('option', this.element).remove();
      self._dictionary = {};

      self.addRow(results, self._dropdownMenu);

      this._setupListClickHandlers();
      if ($.type(this.options.source) != 'string') {
        this.updateSelect();
      }
      self.element.trigger('change');
    },

    // private
    _updateResults: function (results) {
      var self = this;
      if ($.isEmptyObject(results) == true) {
        results = this._dictionary;
      } else {
        this.openMenu();
      }

      $('.combobox-dropdown-item', this._dropdownMenu).remove();

      $('option', this.element).remove();
      self.addRow(results, self._dropdownMenu);

      this._setupListClickHandlers();
      if ($.type(this.options.source) != 'string') {
        this.updateSelect();
      }
    },

    updateSelect: function (term) {
      var self = this;
      if (term == null) var term = this._search.val();

      $('option', this.element).each(function () {
        if ($(this).html().toLowerCase() == term.toLowerCase()) {
          $(this).prop('selected', true);
        } else {
          $(this).prop('selected', false);
        }
      });
      this.element.prepend('<option value=""></option>');
    },

    _specialChars: function (string) {
      string = string.replace('&amp;', '&');
      string = string.replace('&laquo;', '«');
      string = string.replace('&raquo;', '»');

      return string;
    },

    _spinnerOn: function () {
      //	$('i', this._dropdownButton).removeClass('fa-caret-down').addClass('fa-spinner fa-spin');
    },

    _spinnerOff: function () {
      //	$('i', this._dropdownButton).removeClass('fa-spinner fa-spin').addClass('fa-caret-down');
    },

    refresh: function () {
      this._destroy();
      this._create();
    },

    setValue: function (newVal) {
      // set by dropdown-item data-value
      if ($('li.combobox-dropdown-item[data-value="' + newVal + '"]', this._dropdownMenu).size() > 0) {
        $('li.combobox-dropdown-item[data-value="' + newVal + '"]', this._dropdownMenu).trigger('click');
      }

      // if no data-value match, match by innerText using :contains
      else if ($('li.combobox-dropdown-item:contains("' + newVal + '")', this._dropdownMenu).size() > 0) {
        $('li.combobox-dropdown-item:contains("' + newVal + '")', this._dropdownMenu).trigger('click');
      }
    },

    toggleMenu: function () {
      if (this._dropdownMenu.is(':visible') == true) {
        this.closeMenu();
      } else {
        this.openMenu();
        this._updateResults();
      }
    },

    openMenu: function () {
      // close other open menus
      $('.combobox-dropdown-menu').css({ display: 'none' });

      this._search.focus();
      this._dropdownMenu.css({ display: 'block' });
      this.element.trigger('open');
    },

    closeMenu: function () {
      this._dropdownMenu.css({ display: 'none' });
      $('.combobox-dropdown-item.focus', this._dropdownMenu).removeClass('focus');
      this.element.trigger('close');
    },

    _setOption: function (k, v) {
      this._super(k, v);
    },

    _destroy: function () {
      this.element.removeClass('combobox-ui');
      this.element.unwrap();
      this._dropdownButton.remove();
      this._dropdownMenu.remove();
      this._search.remove();
      this._dictionary = {};
      this.element.css({ display: 'block' });
    },

  });
}(jQuery));
